import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, CadastrarParametroSistemaRequest } from './types';

// ACTIONS
import {
	cadastrarParametroSistemaSuccess,
	cadastrarParametroSistemaFailure,
} from './actions';

function* cadastrarParametroSistema(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: CadastrarParametroSistemaRequest } = request;

	const body = { ...payload };

	delete body.id;

	const response: ApiResponse = yield call(
		postApi,
		token || '',
		PATH_SGU_API,
		`parametros-sistema`,
		body,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(cadastrarParametroSistemaSuccess(response));
	} else {
		yield put(cadastrarParametroSistemaFailure());
	}
}

export default all([
	takeLatest(Types.CADASTRAR_PARAMETRO_SISTEMA, cadastrarParametroSistema),
]);
